/*
 D3.js Slider
 Inspired by jQuery UI Slider
 Copyright (c) 2013, Bjorn Sandvik - http://blog.thematicmapping.org
 BSD license: http://opensource.org/licenses/BSD-3-Clause
 */

// April/May 2015.
// The code (from https://github.com/turban/d3.slider) was simplified and some bugs fixed.
// The original copyright notice is retained above (with the link to the BSD license permitting use
// of and modification of this code).

'use strict';

var d3dat = (function (lib) {

	lib.slider = function () {
		var step = 0.01, axis, axisOrient = 'top', margin = 30, sliderValues = [], value, snap = true,
			scale, $log, axisScale, dispatch = d3.dispatch('slide', 'slideend', 'click'), formatPercent = d3.format('.2%'),
			sliderHandle, sliderLength, widthAdjustment, disable = false, self, lastDragTimeMs;

		function _slider(selection) {
			selection.each(function () {
				self = this;

				if (!$log) {
					$log = {};
					$log.debug = $log.error = $log.info = $log.log = $log.warn = function () { }; // no-op
				}

				axis = d3.svg.axis().orient(axisOrient);
				value = value || scale.domain()[0];
				var div = d3.select(this).classed('d3-slider d3-slider-horizontal', true);
				var drag = d3.behavior.drag();
				drag.on('dragend', function () {
					lastDragTimeMs = new Date().valueOf();
					dispatch.slideend(d3.event, value);
				});
                
				sliderHandle = div.append('a')
					.classed('d3-slider-handle', true)
					.attr('xlink:href', '#')                  
					.on('click', stopPropagation)
					.call(drag);

				div.on('click', onClickHorizontal);

				sliderLength = parseInt(div.style('width'), 10);

				widthAdjustment = 7/sliderLength;
				sliderHandle.style('width', formatPercent(scale(value) + widthAdjustment));
				drag.on('drag', onDragHorizontal);
                
				createAxis(div);

				disableOrEnableSlider();
			});
		}

		// Getter/setter functions
		_slider.margin = function (_) {
			if (!arguments.length) return margin;
			margin = _;

			return _slider;
		};

		_slider.sliderValues = function (_) {
			if (!arguments.length) return sliderValues;
			sliderValues = _;
			scale = d3.scale.ordinal().domain(sliderValues).rangePoints([0, 1], 0.5);

			return _slider;
		};

		_slider.value = function (_) {
			if (!arguments.length) return value;
			if (value) {
				moveHandle(stepValue(_));
			}
			value = _;

			return _slider;
		};

		_slider.snap = function (_) {
			if (!arguments.length) return snap;
			snap = _;

			return _slider;
		};

		_slider.axisOrient = function (_) {
			if (!arguments.length) return axisOrient;
			axisOrient = _;

			return _slider;
		};

		_slider.log = function (_) {
			if (!arguments.length) return $log;
			$log = _;

			return _slider;
		};

		_slider.disable = function (_) {
			if (!arguments.length) return disable;
			disable = _;
			disableOrEnableSlider();

			return _slider;
		};

		d3.rebind(_slider, dispatch, 'on');

		return _slider;

		/////////////////////////////

		function createAxis(dom) {            
			axisScale = scale.copy().rangePoints([0, sliderLength], 0.5);
			axis.scale(axisScale);
            
			var svg = dom.append('svg')
				.classed('d3-slider-axis d3-slider-axis-' + axis.orient(), true)
				.on('click', stopPropagation);

			var g = svg.append('g');
            
			svg.style('margin-left', -margin + 'px');

			svg.attr({
				width: sliderLength + margin * 2,
				height: margin
			});

			if (axis.orient() === 'top') {
				svg.style('top', -margin + 'px');
				g.attr('transform', 'translate(' + margin + ',' + margin + ')');
			} else { // bottom
				g.attr('transform', 'translate(' + margin + ',0)');
			}

			g.call(axis);
		}

		function onClickHorizontal() {
			//$log.debug("onClickHorizontal");
			var pos = Math.max(0, Math.min(sliderLength, d3.event.offsetX || d3.event.layerX));
			moveHandle(scale.invert ?
				stepValue(scale.invert(pos / sliderLength))
				: nearestTick(pos / sliderLength));
			// LAN-437. Because of the way we're doing the styling on the slider handle and we need to have a solid "fill" effect all the way to the left, then
			// we must allow the click to go through the thumb (which includes the filled in area). Thus, we can get a click event fired at the same time as
			// the thumb getting dragged. To prevent that we use the simple scheme below.
			if (!lastDragTimeMs || new Date().valueOf() - lastDragTimeMs > 500) {
				dispatch.click(d3.event, value);
			}
			else {
				$log.debug('d3 slider component: Will not fire click event');
			}
		}

		function onDragHorizontal() {
			if (disable) return;
			//$log.debug("onDragHorizontal");
			var pos = Math.max(0, Math.min(sliderLength, d3.event.x));
			moveHandle(scale.invert ?
				stepValue(scale.invert(pos / sliderLength))
				: nearestTick(pos / sliderLength));
		}

		function stopPropagation() {
			d3.event.stopPropagation();
		}
        
		function moveHandle(newValue) {
			var currentValue = value,
				oldPos = formatPercent(scale(stepValue(currentValue)) + widthAdjustment),
				newPos = formatPercent(scale(stepValue(newValue)) + widthAdjustment),
				position = 'width';
			if (oldPos !== newPos) {

				value = newValue;

				if (d3.event) {
					dispatch.slide(d3.event.sourceEvent || d3.event, value);
				}
                
				sliderHandle.transition()
					.styleTween(position, function () { return d3.interpolate(oldPos, newPos); })
					.duration(250);
			}
		}
        
		function stepValue(val) {

			if (val === scale.domain()[0] || val === scale.domain()[1]) {
				return val;
			}

			var alignValue = val;
			if (snap) {
				alignValue = nearestTick(scale(val));
			} else {
				var valModStep = (val - scale.domain()[0]) % step;
				alignValue = val - valModStep;

				if (Math.abs(valModStep) * 2 >= step) {
					alignValue += (valModStep > 0) ? step : -step;
				}
			}

			return alignValue;
		}
        
		function nearestTick(pos) {
			var ticks = scale.ticks ? scale.ticks() : scale.domain();
			var dist = ticks.map(function (d) { return pos - scale(d); });
			var i = -1,
				index = 0,
				r = scale.ticks ? scale.range()[1] : scale.rangeExtent()[1];
			do {
				i++;
				if (Math.abs(dist[i]) < r) {
					r = Math.abs(dist[i]);
					index = i;
				}
			} while (dist[i] > 0 && i < dist.length - 1);

			//$log.debug("nearestTick returns " + ticks[index]);
			return ticks[index];
		}

		function disableOrEnableSlider() {
			if (!self) return;
			var div = d3.select(self);
			div.style('pointer-events', disable ? 'none' : 'auto');
			div.classed('d3-slider-disabled', disable);
		}
	};

	return lib;

}(d3dat || {}));
